import { cn } from "@/lib/utils"
import { ReactNode } from "react"
import FlexBreak from "./FlexBreak"

function Hero({ children, bg, className }: { children: ReactNode, bg?: ReactNode, className?: string }) {
    return <section className={ cn(["h-[87lvh] sm:h-[max(82dvh,440px)] min-h-fit relative overflow-hidden", className]) }>
        { bg && <div className={ "w-full h-full pointer-events-none absolute -z-10" }>{ bg }</div> }
        <FlexBreak className="h-full m-auto max-w-screen-2xl justify-around flex-wrap">
            { children }
        </FlexBreak>
    </section>
}
export default Hero

export function HeroBG({ className }: { className?: string }) {
    return <div className={ cn(["noAds w-full pointer-events-none aspect-square absolute bottom-[-50vw] sm:bottom-auto sm:right-[-50vw] -z-10 bg-nfPurple-400/20 rotate-45 backdrop-blur-sm",
        className]) }> </div>
} 